import { resolveMediaUrl } from './mediaUrl';

const parseCardCaption = (caption) => {
  if (!caption) {
    return { title: '', subtitle: '' };
  }

  try {
    const parsed = JSON.parse(caption);
    return {
      title: parsed.title || '',
      subtitle: parsed.subtitle || '',
    };
  } catch {
    return { title: '', subtitle: '' };
  }
};

export const parseHomeTtgContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const ttgSection = page.sections.find((section) => section.key === 'ttg');
  if (!ttgSection) {
    return null;
  }

  const fields = ttgSection.fields || {};
  const eagleMedia = ttgSection.media?.groups?.eagle?.[0] || null;
  const cardMedia = ttgSection.media?.groups?.cards || [];

  if (!fields.quote || !eagleMedia?.url || cardMedia.length === 0) {
    return null;
  }

  const cards = cardMedia
    .map((item) => {
      const parsed = parseCardCaption(item.caption);
      if (!parsed.title || !item.url) {
        return null;
      }

      return {
        title: parsed.title,
        subtitle: parsed.subtitle || '',
        icon: resolveMediaUrl(item.url),
      };
    })
    .filter(Boolean);

  if (cards.length === 0) {
    return null;
  }

  return {
    quote: fields.quote,
    eagle: resolveMediaUrl(eagleMedia.url),
    cards,
  };
};
